import { auditLogsApi } from '@/features/audit-logs/audit-logs.api.ts';
import { authApi } from '@/features/auth/auth.api.ts';
import { unauthorizedMiddleware } from '@/redux/unauthorized.middleware.ts';
import { authPersistenceMiddleware } from '@/features/auth/auth.middleware.ts';
import { dataMaskingApi } from '@/features/data-masking/data-masking.api.ts';
import { fundManagementApi } from '@/features/fund-management/fund-management.api.ts';
import { investorManagementApi } from '@/features/investor-management/investor-management.api.ts';
import { investmentsApi } from '@/features/investor-management/investments.api.ts';
import { referenceDataApi } from '@/features/reference-data/reference-data.api.ts';
import { reportsApi } from '@/features/reports/reports.api.ts';
import { userPreferencesApi } from '@/features/user-preferences/user-preferences.api.ts';

export const extraMiddleware = [
  authPersistenceMiddleware,
  unauthorizedMiddleware,
  auditLogsApi.middleware,
  authApi.middleware,
  dataMaskingApi.middleware,
  fundManagementApi.middleware,
  investorManagementApi.middleware,
  investmentsApi.middleware,
  referenceDataApi.middleware,
  reportsApi.middleware,
  userPreferencesApi.middleware,
];
